import React from 'react';
import { useNavigate } from "react-router-dom";
import { ActionIcon, Text } from '@mantine/core';
import { IconCheck, IconPlayerPause, IconPlayerPlay, IconX  } from '@tabler/icons-react';
import TestsApi from "../../api/TestsApi";
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';

export function PauseVariations({ selectedMemberWebsite, pageId, taguchiTestId, varId, currentVariations, testsIdShow, pausedvariation, setMarksalestime, TestOptimizeReport, systemUsageLoader }:any) {
  const navigate = useNavigate();

  // The generic box, kept as a fallback when the engine has no reading
  const openGenericPauseBox = (varId, currentVariations) => {
      modals.openConfirmModal({
        trapFocus: false,
        title: 'Pause Variations',
        children: (
          <Text size="sm" style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%' }}>
            Warning: <br />
            This is an advanced option.<br />
            Pausing a test version alters the algorithm. Only apply once a test has gotten substantial data to confirm a version is a definite loser.<br />
            Also be aware that pausing a version makes the variable influence option invalid.<br />
            All variations not paused will continue to run and statistical significance will work properly.<br />
            To view accurate results after you pause a variation we recommend that you change the date range start date to the date when you paused.
          </Text>
        ),
        labels: { confirm: 'Ok', cancel: 'Cancel' },
        onCancel: () => console.log('Cancel'),
        onConfirm: () => {
          handlePauseResumeVariations(varId, currentVariations);
        },
      });
  }

  // Pause warning (Build 1 change 42): the engine's view of this variation from last night's run
  const handlePauseVariations = (varId, currentVariations) => {
    if (pausedvariation !== 0) {
      handlePauseResumeVariations(varId, currentVariations);
      return;
    }
    TestsApi.getpausewarning({ system_website_id: selectedMemberWebsite, page_id: pageId, variation_no: varId })
      .then(response => (response.ok ? response.json() : null))
      .then(data => {
        const w = data && data.status === 1 ? data.data : null;
        if (!w || !w.message || w.kind === 'none') {
          openGenericPauseBox(varId, currentVariations);
          return;
        }
        modals.openConfirmModal({
          trapFocus: false,
          title: w.kind === 'control' ? 'Pause Control' : 'Pause Variation',
          children: (
            <Text size="sm" style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%' }}>{w.message}</Text>
          ),
          labels: { confirm: w.confirm || 'Pause anyway', cancel: 'Cancel' },
          onConfirm: () => handlePauseResumeVariations(varId, currentVariations),
        });
      })
      .catch(() => openGenericPauseBox(varId, currentVariations));
  }

  const handlePauseResumeVariations = (varId, currentVariations) => {
    systemUsageLoader(true);
    TestsApi.pauseresumevariation({
      system_website_id:selectedMemberWebsite,
      taguchi_test_id:taguchiTestId,
      page_id:pageId,
      variation_no: varId,
      tests_id: testsIdShow
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if (data.status === 1) {
        systemUsageLoader(false);
        setMarksalestime(data.data.updated_time);
        TestOptimizeReport();
        notifications.show({
          color: 'green',
          icon: <IconCheck size="1.1rem" />,
          title: 'Success',
          message: data.message,
        });
      } else {
        notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: data.message,
        });
        systemUsageLoader(false);
      }
    })
    .catch(error => {
      systemUsageLoader(false);
      console.error("API Error:", error);
    });
  }

  return (
    <>
      {pausedvariation === 0 ? (
        <ActionIcon
          variant="default"
          size="md"
          title="Pause Test"
          onClick={() => handlePauseVariations(varId, currentVariations)}
        >
          <IconPlayerPause size="1.1rem" />
        </ActionIcon>
      ) : (
        <ActionIcon
          variant="default"
          size="md"
          title="Resume Test"
          onClick={() => handlePauseVariations(varId, currentVariations)}
        >
          <IconPlayerPlay size="1.1rem" />
        </ActionIcon>
      )}
    </>
  );
}
